import './PriorityStar.css';

import * as React from 'react';

export interface Props {
    isPriority: boolean;
    onToggle: () => void;
}

const PriorityStar: React.SFC<Props> = ({ isPriority, onToggle }) => {
    const svgName = isPriority ? 'star-active' : 'star-hover';
    const altText = svgName.includes('active') ? 'Prioritized' : 'Not prioritized';
    return (
        <button
            className="btn-div__inline btn-has-hover-img"
            aria-label="Toggle lesson priority"
            onClick={() => {
                if (onToggle) {
                    onToggle();
                }
            }}>
            <img alt={altText} src={'/assets/images/icons/v2/ico-' + svgName + '.svg'} className="priority-icon non-hover-icon" />
            <img alt="" src="/assets/images/icons/v2/ico-star.svg" className="priority-icon hover-icon d-none" />
        </button>
    );
};

PriorityStar.defaultProps = {};
PriorityStar.displayName = 'PriorityStar';

export default PriorityStar;
